<template>
  <transition name="custom-classes-transition">
    <div v-if="selectedRecords.length > 0" class="song-select-all-bar" :class="{ 'is-processing': isDeleting }">
      <div class="song-select-all-bar-content">
        <div class="song-select-all-bar-left">
          <button class="song-select-all-bar-close" @click="$emit('close')" :disabled="isDeleting">
            <IconX />
          </button>
          <span class="song-select-all-bar-count">{{ selectedRecords.length }} {{ pluralNoun }} selected</span>
        </div>

        <div class="song-select-all-bar-separator"></div>

        <div class="song-select-all-bar-actions">
          <button class="song-select-all-bar-action song-select-all-bar-action-danger" @click="deleteSelected" :disabled="isDeleting">
            <IconTrash />
            <span>{{ isDeleting ? 'Deleting...' : 'Delete' }}</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { IconX, IconTrash } from '@/Icons/IconBase'
import { BULK_DELETE } from '@/store/actions'
import bulkDeleteEffects from '@/components/bulkDeleteEffects'

export default {
  name: 'BulkDeleteBar',

  components: {
    IconX,
    IconTrash
  },

  props: {
    selectedRecords: {
      type: Array,
      default: () => []
    },
    url: {
      type: String,
      required: true
    },
    idsKey: {
      type: String,
      required: true
    },
    singularNoun: {
      type: String,
      required: true
    },
    pluralNoun: {
      type: String,
      required: true
    },
    // Key into bulkDeleteEffects describing what the delete does to related records.
    effectsFor: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      isDeleting: false
    }
  },

  methods: {
    deleteSelected() {
      this.$store.dispatch('confirm', this.confirmationMessage(this.selectedRecords.length))
        .then(resp => {
          if (resp === true) {
            this.bulkDelete()
          }
        })
        .catch(err => console.log(err))
    },

    bulkDelete() {
      const ids = this.selectedRecords.map(r => r.id)
      this.isDeleting = true

      this.$store.dispatch(BULK_DELETE, { url: this.url, idsKey: this.idsKey, ids })
        .then(() => {
          this.$store.commit('alert', `${ids.length} ${this.countedNoun(ids.length)} deleted.`)
          this.$emit('deleted')
          this.$emit('close')
        })
        .catch(err => {
          if (err.response && err.response.data.message) {
            this.$store.commit('error', err.response.data.message)
          } else {
            this.$store.commit('error', `Selected ${this.pluralNoun} could not be deleted.`)
          }
        })
        .finally(() => {
          this.isDeleting = false
        })
    },

    confirmationMessage(count) {
      const intro = `<p>You're about to delete <strong>${count} ${this.countedNoun(count)}</strong>. This can't be undone.</p>`
      const effects = bulkDeleteEffects[this.effectsFor]

      if (!effects) {
        return intro
      }

      const items = effects.alsoWill.map(effect => `<li>${effect}</li>`).join('')
      return `<div class="content has-text-left">${intro}<p>This will also:</p><ul>${items}</ul></div>`
    },

    countedNoun(count) {
      return count === 1 ? this.singularNoun : this.pluralNoun
    }
  }
}
</script>
